import APIClient from '@/shared/http/clients/api'

const resourceName = 'AprAnalisePreliminarRisco'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllRelatorioAPR = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllRelatorioAPR?limit=${limit}&index=${index}`, data, config)
const GetRelatorioQuantidadeAPR = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetRelatorioQuantidadeAPR?limit`, data, config)
const GetAllRelatorioAPRPDF = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllRelatorioAPRPDF?limit`, data, config)

const ApruserRepository = {
  GetAllRelatorioAPR,
  GetAllRelatorioAPRPDF,
  GetRelatorioQuantidadeAPR
}

export default ApruserRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprReport.js